export function getter(key: string) {
  if (!window.localStorage) return;
  try {
    return JSON.parse(localStorage.getItem(key));
  } catch (err) {
    console.error(err);
  }
}

export function setter(key: string, data: any) {
  if (!window.localStorage) return;
  localStorage.setItem(key, JSON.stringify(data));
}